export interface TypeResponse {
    /** @format int32 */
    value?: number
    name?: string | null
    translation?: string | null
    /** @format int32 */
    color?: number | null
}

/**
 * @param model
 * @param fallBack if no suitable value is found on the model the fallback will be returned
 */
export const getTypeResponseTranslation = (model: TypeResponse, fallBack?: string | number): string | null => {
    if (model) {
        if (model.translation) return model.translation
        if (model.name) return model.name
        if (model.value) return String(model.value)
    }

    if (!!fallBack) return fallBack.toString()

    return null
}
